//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      iconStyling: false,
      textStyling: false
    };
  },
  methods: {
    $ready: function $ready() {
      if (this.spec.text) {
        this.textStyling = true;
      } else {
        this.iconStyling = true;
      }
    },
    buttonSpec: function buttonSpec(item) {
      return Object.assign({}, item, {
        view: "button-v1",
        styleClasses: ["text"]
      });
    }
  }
};